export const WIDGET_FILE_LIST_TYPE = 'file-list';
